












































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Getter, Mutation } from 'vuex-class';
import { SwTabGroup, SwTabPage, TabProps } from '@libs-uuif/shared/sw-tab-layout';
import { MswPageTheme } from '@/shared/msw-types';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { currentUserKey } from '@/shared/msw-constants';
import * as decode from 'jwt-decode';
import { InfoState, SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { MswApiService } from '@/shared/msw-api-service';
import { ApiError } from '@libs-uuif/shared/api-service';
import { AllUsersListType, PartyGroupPermissionItem, PartyGroupPermissionSection, PermissionApiResponse, PermissionChoice, ScopeUserGroupResponse, UserGroupAPIResponse, UserGroupDetailsResponse, UserListDetail } from '../../types';
import ListTenantsForUserGroup from './list-tenants-for-user-group.vue';
import { SwSpinningProgress } from '@libs-uuif/shared/sw-progress';

const cssPrefix = 'user-group-extension';

@Component({
  components: {
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwIcon,
    SwScrollView,
    SwSelect,
    SwTabGroup,
    SwIconButton,
    SwTabPage,
    ListTenantsForUserGroup,
    SwSpinningProgress,
  },
})

export default class UserGroupExtension extends SwExtendedVue {
  cssPrefix = cssPrefix;

  formLabelWidth:string = '40%';
  extensionUserGroupTabId: string = 'user-groups-users-tab';
  permissionList: PartyGroupPermissionSection[] = [];
  customerTab: any = '';
  editMode: boolean = false;
  userTab: any = '';
  permissionTab: any = '';
  userGroupTabsProps: TabProps[] = [
    { tabId: 'user-groups-customer-tab', label: this.customerTab },
    { tabId: 'user-groups-users-tab', label: this.userTab },
    { tabId: 'user-groups-permission-tab', label: this.permissionTab },
  ];
  permissionCheckBox : boolean[] = [];

  @Getter
  effectivePageTheme: MswPageTheme;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Prop({ type: String, required: true })
  selectedTab: string;

  @Prop({ type: Boolean })
  triggerUserGroupsAndUsersForUserGroupApi: boolean;

  @Watch('triggerUserGroupsAndUsersForUserGroupApi', { immediate: true })
  handleUpdateUsersForUserGroup(triggerApi: boolean) {
    if (triggerApi) Promise.all([this.loadUserGroupDetail(), this.loadUsersForUserGroups()]);
  }

  @Watch('selectedUserGroup')
  handleSelectedUserGroup() {
    this.triggerApis();
  }

  @Watch('selectedTab')
  loadSelectedTab() {
    this.extensionUserGroupTabId = this.selectedTab;
    if (this.selectedTab === 'user-groups-help') {
      this.extensionUserGroupTabId = 'user-groups-users-tab';
    }
  }

  get isOrgBased() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    return token.hasOwnProperty('orgbased') && token?.orgbased === 'YES';
  }

  get isLoading() {
    return this.$store.getters['loading'];
  }

  get loadingUsersForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getLoadingUsersForUserGroup'];
  }

  get selectedUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroup'] || [];
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'][0] || [];
  }

  get usersList() {
    return this.usersForUserGroup?.assignedusers || [];
  }

  get usersForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getUsersForUserGroup'] || [];
  }

  get permissionsForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getPermissionsForUserGroup'] || [];
  }

  changeTabId(value: string) {
    if (value === 'user-groups-users-tab') {
      this.$emit('change-tab-id', 'user-groups-users-tab', true);
      this.setHelpId('user-groups-users-tab');
    } else if (value === 'user-groups-customer-tab') {
      this.$emit('change-tab-id', 'user-groups-customer-tab', true);
      this.setHelpId('user-groups-customer-tab');
    } else if (value === 'user-groups-permission-tab') {
      this.$emit('change-tab-id', 'user-groups-permission-tab', true);
      this.setHelpId('user-groups-permission-tab');
    }
    window.parent.postMessage({ showHelp : true }, '*');
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
    window.parent.postMessage({ route: 'user-groups', helpId: temp }, '*');
  }

  addNewUser() {
    this.$emit('add-new-user');
  }

  getPermissionOptions(data: any): SelectOption[] {
    return data.map((obj: any) => {
      return {
        id: obj.permissionItemChoiceValue,
        value: obj.permissionItemChoiceValue,
        label: obj.permssionItemChoiceName,
      };
    });
  }

  getPermissionName(data: any) {
    let selectedModeName = '';
    data.map((obj: any) => {
      if (obj.isSelected === 'TRUE') {
        selectedModeName = obj.permssionItemChoiceName;
      }
    });
    return selectedModeName;
  }

  removeUser(user: UserListDetail) {
    this.$emit('remove-user', user);
  }

  onChangeUserGroupPermission(value: string, functionality: PartyGroupPermissionItem) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.changePermssion(this.selectedUserGroup[0], value, functionality.functionalityname)
    .then((rsp: UserGroupAPIResponse) => {
      this.$store.commit('stopLoading');
      if (rsp.operationStatus === 'NOK') {
        this.formatPermissions();
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: rsp?.msgDesc });
      } else {
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: rsp?.msgDesc });
        this.loadProductGroupsForUserGroup();
      }
    });
  }

  loadUserGroupDetail() {
    MswApiService.userGroup.listUserGroupDetail(this.selectedUserGroup[0])
    .then((resp: UserGroupDetailsResponse) => {
      if (resp?.operationStatus === 'OK') {
        this.$store.commit('MswUserGroupStoreModule/updateUserGroup', resp?.userGroups[0] || {});
      }
    })
    .catch((error: ApiError) => {
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  loadProductGroupsForUserGroup() {
    this.$store.commit('MswUserGroupStoreModule/setLoadingTenantsForUserGroup', true);
    MswApiService.createCustomer.listProductGroupForUserGroup(this.selectedUserGroup[0])
    .then((resp: ScopeUserGroupResponse) => {
      this.$store.commit('MswUserGroupStoreModule/setLoadingTenantsForUserGroup', false);
      this.$store.commit('MswUserGroupStoreModule/setTenantsForUserGroup', resp?.content);
    })
    .catch((error: ApiError) => {
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  loadUsersForUserGroups() {
    this.$store.commit('startLoading');
    this.$store.commit('MswUserGroupStoreModule/setLoadingUsersForUserGroup', true);
    MswApiService.userGroup.fetchUsersForUserGroup(this.selectedUserGroup[0])
    .then((resp: AllUsersListType) => {
      this.$store.commit('stopLoading');
      this.$store.commit('MswUserGroupStoreModule/setLoadingUsersForUserGroup', false);
      this.$store.commit('MswUserGroupStoreModule/setUsersForUserGroup', resp?.content);
    })
    .catch((error: ApiError) => {
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  formatPermissions() {
    const permissionsForUserGroup: PartyGroupPermissionSection[] = JSON.parse(JSON.stringify(this.permissionsForUserGroup));
    permissionsForUserGroup?.forEach((item: PartyGroupPermissionSection) => {
      if (item?.partyGroupPermissionSectionName.replace(/\s+/g, '').toLowerCase() === 'accesstocsc') {
        item.partyGroupPermissionSectionName = 'Access to Product consoles';
      }
      if (item?.partyGroupPermissionSectionName.replace(/\s+/g, '').toLowerCase() === 'accesstoproductmanagement') {
        item.partyGroupPermissionSectionName = 'Access to Platform operations';
      }
    });
    const formattedPermissionsForUserGroup: PartyGroupPermissionSection[] = permissionsForUserGroup?.map((obj: PartyGroupPermissionSection) => {
      this.permissionCheckBox.push(false);
      const editedPermissions = obj.partyGroupPermissionItems.map((ele: PartyGroupPermissionItem) => {
        let valueSelected = '';
        ele.permissionChoices.map((item: PermissionChoice) => {
          if (item.isSelected === 'TRUE') {
            valueSelected = item.permissionItemChoiceValue;
          }
        });
        return {
          functionalityname: ele.functionalityname,
          permissionChoices: ele.permissionChoices,
          value: valueSelected,
        };
      });
      return {
        partyGroupPermissionSectionName: obj.partyGroupPermissionSectionName,
        partyGroupPermissionItems: editedPermissions,
      };
    }) || [];
    this.permissionList = formattedPermissionsForUserGroup;
  }

  loadPermissionsForUserGroup() {
    this.$store.commit('MswUserGroupStoreModule/setLoadingPermissionsForUserGroup', true);
    MswApiService.createCustomer.getUserGroupPermissions(this.selectedUserGroup[0])
    .then((resp: PermissionApiResponse) => {
      this.$store.commit('MswUserGroupStoreModule/setLoadingPermissionsForUserGroup', false);
      this.$store.commit('MswUserGroupStoreModule/setPermissionsForUserGroup', [...resp?.content?.PartyGroupPermissionSections || []]);
      this.formatPermissions();
    })
    .catch((error: ApiError) => {
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  triggerApis() {
    Promise.allSettled([this.loadProductGroupsForUserGroup(), this.loadUsersForUserGroups(), this.loadPermissionsForUserGroup()])
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  created() {
    this.customerTab = this.$t('userGroups.Customers');
    this.userTab = this.$t('userGroups.users');
    this.permissionTab = this.$t('userGroups.permissions');
    this.userGroupTabsProps = [
      { tabId: 'user-groups-customer-tab', label: this.customerTab },
      { tabId: 'user-groups-users-tab', label: this.userTab },
      { tabId: 'user-groups-permission-tab', label: this.permissionTab },
    ];
    this.loadSelectedTab();
    this.triggerApis();
  }

}
